<template>
  <div class="w-full">
    <a :href="link" target="_blank" class="w-full">
      <Card class="w-full">
        <template #title>
          <h3>{{ title }}</h3>
        </template>
        <template #content>
          <p>{{ desc }}</p>
          <h5 class="subtitle">{{ link }}</h5>
        </template>
      </Card>
    </a>
  </div>
</template>

<script>
import Card from 'primevue/card'

export default {
  name: 'ExchangeLink',
  props: ['title', 'desc', 'link'],
  components: {
    Card
  },
  mounted: function () {
    this.changeTitle('Links')
  }
}
</script>

<style scoped>
.card-cover {
  width: 220px !important;
  height: 200px;
  background-size: 10% 10% !important;
  overflow: hidden;
}

.subtitle {
  text-align: right;
  margin: 0px 10px 10px 0px;
}
</style>
